import {
  emailDefaultBackgroundColour,
  emailDefaultTextColour,
  emailFontFamily,
  linkColour,
  tableWidth,
} from '../pro-report-email-styles';

function ProReportEmailFeedback() {
  const tdStyle = {
    margin: 0,
    backgroundColor: emailDefaultBackgroundColour,
    color: emailDefaultTextColour,
    fontFamily: emailFontFamily,
    width: tableWidth,
  };
  return (
    <table width={tableWidth} role="presentation">
      <tr>
        <td style={tdStyle}>
          <b>Your opinion matters!</b>
        </td>
      </tr>
      <tr>
        <td style={tdStyle}>
          Please take 5 minutes to provide feedback on the PRO Report’s content{' '}
          <a
            href="https://forms.cloud.microsoft/pages/responsepage.aspx?id=JoOfHD15akSsgCmczmU8LnwTuysRMqREl7ffQO8Gk-hUOEFGTEVEMzc1Nk0zWUc5TDg0MDVOM05QUy4u&route=shorturl"
            target="_blank"
            rel="noreferrer"
            style={{
              color: linkColour,
              textDecoration: 'none',
              fontWeight: 'bold',
            }}
          >
            here
          </a>
          .
        </td>
      </tr>
    </table>
  );
}

export default ProReportEmailFeedback;
